export default __webpack_public_path__ + "static/media/macbook-face.a82e01fa.png";